import React from 'react'

const TaskInput = ({placeholder, title, icon, value, onChange, name, disabled, type = "text"}) => {
  return (
    <div className='flex flex-col gap-2'>
        <h1 className='text-sm font-bold'>{title}</h1>
        <div className='relative'>
          <input 
            className={`w-full p-2 pl-10 border border-gray-200 rounded-lg ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            name={name}
            disabled={disabled}
          />
          <img 
            src={icon} 
            alt="task name" 
            className='absolute left-3 top-1/2 -translate-y-1/2'
          />
        </div>
    </div>
  )
}

export default TaskInput